var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Grid2 as MuiGrid, Button, CircularProgress, } from '@mui/material';
import React from 'react';
import { Colors } from '../../themes/theme';
export var PrevButton = function (_a) {
    var onClick = _a.onClick, _b = _a.children, children = _b === void 0 ? 'Voltar' : _b, props = __rest(_a, ["onClick", "children"]);
    return (_jsx(Button, __assign({ "data-testid": "btn-voltar-step", onClick: onClick, variant: "text", sx: {
            backgroundColor: 'transparent',
            color: Colors.AZUL_GOV,
            width: '100%',
        } }, props, { children: children })));
};
export var NextButton = function (_a) {
    var onClick = _a.onClick, _b = _a.children, children = _b === void 0 ? 'Avançar' : _b, props = __rest(_a, ["onClick", "children"]);
    return (_jsx(Button, __assign({ "data-testid": "btn-avancar-step", onClick: onClick, variant: "contained", sx: {
            backgroundColor: Colors.AZUL_GOV,
            color: Colors.BRANCO_GOV,
            width: '100%',
        } }, props, { children: children })));
};
export var WizardButtons = function (_a) {
    var prevText = _a.prevText, prevClick = _a.prevClick, nextText = _a.nextText, nextClick = _a.nextClick, _b = _a.isSubmitting, isSubmitting = _b === void 0 ? false : _b, _c = _a.buttonNextVisible, buttonNextVisible = _c === void 0 ? true : _c, _d = _a.buttonNextDisabled, buttonNextDisabled = _d === void 0 ? false : _d;
    return (_jsxs(MuiGrid, { container: true, spacing: 1, sx: {
            mt: 4,
            flexDirection: { xs: 'column', md: 'row' },
        }, children: [_jsx(MuiGrid, { size: { xs: 12, md: 6 }, order: { xs: 2, md: 1 }, sx: { textAlign: { md: 'right', xs: 'center' } }, children: _jsx(PrevButton, { onClick: prevClick, children: prevText !== null && prevText !== void 0 ? prevText : 'Voltar' }) }), _jsx(MuiGrid, { size: { xs: 12, md: 6 }, order: { xs: 1, md: 2 }, children: buttonNextVisible && (_jsxs(NextButton, { startIcon: isSubmitting && _jsx(CircularProgress, { size: 24 }), onClick: nextClick, disabled: buttonNextDisabled || isSubmitting, children: [nextText !== null && nextText !== void 0 ? nextText : 'Avançar', isSubmitting ? '...' : ''] })) })] }));
};
